import { newE2EPage } from '@stencil/core/testing';

describe('salla-product-card', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<salla-product-card></salla-product-card>');

    const element = await page.find('salla-product-card');
    expect(element).toHaveClass('hydrated');
  });
});
